/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['bordaValidacao[_ngcontent-%COMP%]{\n    border: 1px solid red !important;\n}\n\ntextoValidacao[_ngcontent-%COMP%]{\n    color: red !important;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9sb2dpbi9ub3ZvLWFjZXNzby9ub3ZvLWFjZXNzby5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9sb2dpbi9ub3ZvLWFjZXNzby9ub3ZvLWFjZXNzby5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/login/novo-acesso/novo-acesso.component.css.shim.ngstyle.ts